import { NavLink, Outlet, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Bike, CreditCard, Headphones, LayoutDashboard, UserPlus, User } from 'lucide-react';
import { useClienteAuthStore } from '@/stores/clienteAuthStore';
import { ClienteNotificationMenu } from '@/components/cliente/ClienteNotificationMenu';
import { cn } from '@/lib/utils';

const MOBILE_PRIMARY = '#FFC107';
const MOBILE_PRIMARY_DARK = '#FFA000';

const nav = [
  { to: '/cliente/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/cliente/financeiro', label: 'Financeiro', icon: CreditCard },
  { to: '/cliente/atendimentos', label: 'FAC', icon: Headphones },
  { to: '/cliente/indicacao', label: 'Indicação', icon: UserPlus },
  { to: '/cliente/perfil', label: 'Perfil', icon: User },
];

export function ClienteLayout() {
  const user = useClienteAuthStore((s) => s.user);

  return (
    <>
      <Helmet>
        <title>Área do cliente — Zeh Motoca</title>
      </Helmet>
      <div className="min-h-screen flex flex-col bg-[#FAFAFA] dark:bg-zinc-950">
        <header
          className="sticky top-0 z-40 border-b border-black/10 shadow-sm"
          style={{ background: `linear-gradient(135deg, ${MOBILE_PRIMARY}, ${MOBILE_PRIMARY_DARK})` }}
        >
          <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3">
            <Link to="/cliente/dashboard" className="flex items-center gap-2 text-black min-w-0">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-black/10">
                <Bike className="h-5 w-5" />
              </span>
              <div className="min-w-0">
                <p className="font-bold text-sm leading-tight truncate">Zeh Motoca</p>
                <p className="text-[11px] text-black/70 truncate max-w-[140px] sm:max-w-xs">
                  {user?.clienteFornecedor?.nome ?? 'Locatário'}
                </p>
              </div>
            </Link>
            <ClienteNotificationMenu />
          </div>
          <nav className="mx-auto max-w-6xl flex gap-1 px-2 pb-2 overflow-x-auto">
            {nav.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-1.5 shrink-0 rounded-lg px-3 py-2 text-xs sm:text-sm font-semibold transition-colors',
                    isActive ? 'bg-black text-[#FFC107]' : 'text-black/80 hover:bg-black/10'
                  )
                }
              >
                <Icon className="h-4 w-4" />
                {label}
              </NavLink>
            ))}
          </nav>
        </header>

        <main className="flex-1 mx-auto w-full max-w-6xl px-4 py-6">
          <Outlet />
        </main>

        <footer className="border-t border-border py-4 text-center text-xs text-muted-foreground">
          <Link to="/zehmotoca" className="hover:underline">
            Site Zeh Motoca
          </Link>
          {' · '}
          <Link to="/login" className="hover:underline">
            Acesso equipe (SIC)
          </Link>
        </footer>
      </div>
    </>
  );
}
